import { FC, ReactNode } from "react";
import { Flex, Heading, Text } from "@chakra-ui/react";

interface Props {
  amount: ReactNode;
  color?: string;
  term: ReactNode;
}

export const PlanBoxPrice: FC<Props> = ({
  color = "th.gray4",
  amount,
  term,
}) => {
  return (
    <Flex align="flex-start">
      <Heading color="th.blueGreen2" variant="th-h2">
        {amount}
      </Heading>
      <Text color={color} mt={{ base: 1, md: 3 }} variant="th-body3">
        {term}
      </Text>
    </Flex>
  );
};
